export const fontSize = function (size) {
    if (size) {
        return window.innerWidth / 1920 * size;
    }
}

// em计算px
export const emComputed = function (emSize) {
    let bodySize = 16;
    if (window.innerWidth < 1440) { // 页面大小变化后
        bodySize = 14; // 媒体查询
    }
    return emSize * bodySize;
}